import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const ACTION_STYLE = {
  // Auth
  login:                { icon:'🔓', label:'Login',                  color:'var(--green)',  bg:'var(--green-bg)'  },
  logout:               { icon:'🔒', label:'Logout',                  color:'var(--muted)',  bg:'var(--bg)'        },
  login_failed:         { icon:'⚠️', label:'Failed Login',            color:'var(--red)',    bg:'var(--red-bg)'    },
  // Jobs
  job_create:           { icon:'📄', label:'Job Created',             color:'var(--blue)',   bg:'var(--blue-light)'},
  job_update:           { icon:'✏️', label:'Job Edited',              color:'var(--amber)',  bg:'var(--amber-bg)'  },
  job_delete:           { icon:'🗑',  label:'Job Deleted',             color:'var(--red)',    bg:'var(--red-bg)'    },
  job_po_update:        { icon:'🔢', label:'PO Number Updated',       color:'var(--purple)', bg:'var(--purple-bg)' },
  job_invoice_update:   { icon:'🧾', label:'Invoice Number Updated',  color:'var(--purple)', bg:'var(--purple-bg)' },
  // Inspections
  inspection_create:    { icon:'📋', label:'Inspection Submitted',    color:'var(--blue)',   bg:'var(--blue-light)'},
  inspection_update:    { icon:'✏️', label:'Inspection Edited',       color:'var(--amber)',  bg:'var(--amber-bg)'  },
  inspection_delete:    { icon:'🗑',  label:'Inspection Deleted',      color:'var(--red)',    bg:'var(--red-bg)'    },
  inspection_review:    { icon:'✅', label:'Inspection Reviewed',     color:'var(--green)',  bg:'var(--green-bg)'  },
  // Settings
  dealership_create:    { icon:'🏢', label:'Dealership Added',        color:'var(--green)',  bg:'var(--green-bg)'  },
  dealership_delete:    { icon:'🏢', label:'Dealership Removed',      color:'var(--red)',    bg:'var(--red-bg)'    },
  location_create:      { icon:'📍', label:'CarSaloon Site Added',   color:'var(--green)', bg:'var(--green-bg)' },
  location_delete:      { icon:'📍', label:'CarSaloon Site Removed', color:'var(--red)',   bg:'var(--red-bg)'   },
  service_create:       { icon:'🔧', label:'Service Added',           color:'var(--green)',  bg:'var(--green-bg)'  },
  service_delete:       { icon:'🔧', label:'Service Removed',         color:'var(--red)',    bg:'var(--red-bg)'    },
  site_location_create: { icon:'🗺',  label:'Inspection Location Added',     color:'var(--green)',  bg:'var(--green-bg)'  },
  site_location_delete: { icon:'🗺',  label:'Inspection Location Removed',   color:'var(--red)',    bg:'var(--red-bg)'    },
  // Users
  user_create:          { icon:'👤', label:'User Created',            color:'var(--green)',  bg:'var(--green-bg)'  },
  user_update:          { icon:'✏️', label:'User Updated',            color:'var(--amber)',  bg:'var(--amber-bg)'  },
  user_deactivate:      { icon:'🚫', label:'User Deactivated',        color:'var(--red)',    bg:'var(--red-bg)'    },
  user_reactivate:      { icon:'✅', label:'User Reactivated',        color:'var(--green)',  bg:'var(--green-bg)'  },
  user_password_reset:  { icon:'🔑', label:'Password Reset',          color:'var(--amber)',  bg:'var(--amber-bg)'  },
  // Staff Induction
  staff_induction_create: { icon:'🦺', label:'Induction Completed',    color:'var(--green)',  bg:'var(--green-bg)'  },
  staff_induction_update: { icon:'✏️', label:'Induction Edited',       color:'var(--amber)',  bg:'var(--amber-bg)'  },
  staff_induction_delete: { icon:'🗑',  label:'Induction Deleted',      color:'var(--red)',    bg:'var(--red-bg)'    },
  staff_induction_invite: { icon:'✉️', label:'Induction Login Sent',   color:'var(--purple)', bg:'var(--purple-bg)' },
  // CS Staff
  employee_create: { icon:'👷', label:'Staff Member Added',   color:'var(--green)', bg:'var(--green-bg)' },
  employee_update: { icon:'✏️', label:'Staff Member Edited',  color:'var(--amber)', bg:'var(--amber-bg)' },
  employee_delete: { icon:'🗑',  label:'Staff Member Deleted', color:'var(--red)',   bg:'var(--red-bg)'   },
  staff_registration_approve: { icon:'✅', label:'Registration Approved',  color:'var(--green)', bg:'var(--green-bg)' },
  staff_registration_reject:  { icon:'↩️', label:'Registration Sent Back', color:'var(--amber)', bg:'var(--amber-bg)' },
  staff_registration_delete:  { icon:'🗑',  label:'Registration Deleted',   color:'var(--red)',   bg:'var(--red-bg)'   },
  announcement_send:   { icon:'📣', label:'Announcement Sent',    color:'var(--blue)', bg:'var(--blue-light)' },
  announcement_delete: { icon:'🗑',  label:'Announcement Deleted', color:'var(--red)',  bg:'var(--red-bg)'   },
  licence_view:               { icon:'🪪', label:'Licence Viewed',         color:'var(--blue)',  bg:'var(--blue-light)' },
  staff_registration_code:    { icon:'🔑', label:'Registration Code',      color:'var(--purple)', bg:'var(--purple-bg)' },
  staff_induction_worker_submit: { icon:'📝', label:'Induction Submitted by Worker', color:'var(--blue)', bg:'var(--blue-light)' },
  // Excel
  excel_export:         { icon:'📥', label:'Excel Downloaded',        color:'var(--purple)', bg:'var(--purple-bg)' },
  excel_upload:         { icon:'📤', label:'Excel Uploaded',          color:'var(--purple)', bg:'var(--purple-bg)' },
  pdf_export:           { icon:'📄', label:'PDF Exported',            color:'var(--purple)', bg:'var(--purple-bg)' },
};

export default function ActivityLog() {
  const navigate = useNavigate();
  const [logs,    setLogs]    = useState([]);
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ action:'', from:'', to:'', page:1 });
  const [total,   setTotal]   = useState(0);
  const [pages,   setPages]   = useState(1);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page: filters.page, limit: 20 };
      if (filters.action) params.action = filters.action;
      if (filters.from)   params.from   = filters.from;
      if (filters.to)     params.to     = filters.to;
      const { data } = await api.get('/activity', { params });
      setLogs(data.logs); setTotal(data.total); setPages(data.pages);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [filters]);

  const fetchStats = useCallback(async () => {
    try { const { data } = await api.get('/activity/stats'); setStats(data.stats); } catch {}
  }, []);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);
  useEffect(() => { fetchStats(); }, [fetchStats]);

  const setFilter = (key, val) => setFilters(f => ({ ...f, [key]: val, page: 1 }));

  const timeAgo = (date) => {
    const diff = (Date.now() - new Date(date)) / 1000;
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
    return `${Math.floor(diff/86400)}d ago`;
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', fontFamily:'Inter,sans-serif' }}>

      {/* Header */}
      <div style={{ background:'var(--surface)', borderBottom:'1px solid var(--border)', padding:'12px 24px', display:'flex', alignItems:'center', gap:'12px', position:'sticky', top:0, zIndex:50, boxShadow:'var(--shadow-sm)' }}>
        <button onClick={() => navigate(-1)} style={backBtn}>← Back</button>
        <div>
          <div style={{ color:'var(--blue)', fontWeight:'500', fontSize:'16px' }}>🕵️ Activity Log</div>
          <div style={{ color:'var(--muted)', fontSize:'11px' }}>All logins and actions across the app</div>
        </div>
      </div>

      <div style={{ maxWidth:'1000px', margin:'0 auto', padding:'22px 16px' }}>

        {/* Most Active Users only */}
        {stats?.byUser?.length > 0 && (
          <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'16px 18px', marginBottom:'18px', boxShadow:'var(--shadow-sm)' }}>
            <div style={{ fontWeight:'500', color:'var(--blue)', fontSize:'13px', marginBottom:'10px' }}>Most Active Users</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'8px' }}>
              {stats.byUser.map(u => (
                <div key={u._id} style={{ background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'20px', padding:'5px 12px', fontSize:'12px', color:'var(--text)' }}>
                  <strong>{u._id}</strong> · {u.count} actions
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Filters */}
        <div style={{ display:'flex', gap:'10px', marginBottom:'18px', flexWrap:'wrap', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'14px 16px' }}>
          <select value={filters.action} onChange={e => setFilter('action', e.target.value)} style={selStyle}>
            <option value="">All Actions</option>
            {Object.entries(ACTION_STYLE).sort((a,b)=>a[1].label.localeCompare(b[1].label)).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
          <input type="date" value={filters.from} onChange={e => setFilter('from', e.target.value)} style={selStyle}/>
          <input type="date" value={filters.to}   onChange={e => setFilter('to', e.target.value)}   style={selStyle}/>
          <button onClick={() => setFilters({ action:'', from:'', to:'', page:1 })} style={{ ...selStyle, cursor:'pointer', color:'var(--muted)' }}>Clear</button>
          <div style={{ marginLeft:'auto', fontSize:'12px', color:'var(--muted)', alignSelf:'center' }}>{total} records</div>
        </div>

        {/* Logs list */}
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', overflow:'hidden', boxShadow:'var(--shadow-sm)' }}>
          {loading ? (
            <div style={{ padding:'60px', textAlign:'center', color:'var(--muted)' }}>Loading activity...</div>
          ) : logs.length === 0 ? (
            <div style={{ padding:'60px', textAlign:'center' }}>
              <div style={{ fontSize:'2.5rem', marginBottom:'12px' }}>🕵️</div>
              <div style={{ color:'var(--blue)', fontWeight:'500' }}>No activity found</div>
            </div>
          ) : (
            <div>
              {logs.map((log, i) => {
                const s = ACTION_STYLE[log.action] || { icon:'•', label:log.action, color:'var(--muted)', bg:'var(--bg)' };
                return (
                  <div key={log._id} style={{ display:'flex', alignItems:'center', gap:'14px', padding:'14px 18px', borderBottom: i<logs.length-1 ? '1px solid var(--bg)' : 'none' }}>
                    <div style={{ width:'38px', height:'38px', borderRadius:'var(--radius)', background:s.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem', flexShrink:0 }}>
                      {s.icon}
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:'8px', flexWrap:'wrap' }}>
                        <span style={{ background:s.bg, color:s.color, fontSize:'11px', fontWeight:'500', padding:'2px 8px', borderRadius:'20px' }}>{s.label}</span>
                        <span style={{ fontSize:'.62rem', color:'var(--hint)', fontFamily:'JetBrains Mono,monospace' }}>{log.userRole}</span>
                      </div>
                      <div style={{ fontSize:'13px', color:'var(--text)', marginTop:'4px' }}>{log.description}</div>
                    </div>
                    <div style={{ textAlign:'right', flexShrink:0 }}>
                      <div style={{ fontSize:'11px', color:'var(--muted)' }}>{timeAgo(log.createdAt)}</div>
                      <div style={{ fontSize:'.65rem', color:'var(--hint)', fontFamily:'JetBrains Mono,monospace', marginTop:'2px' }}>
                        {new Date(log.createdAt).toLocaleTimeString('en-AU',{hour:'2-digit',minute:'2-digit'})}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Pagination */}
        {pages > 1 && (
          <div style={{ display:'flex', justifyContent:'center', gap:'8px', marginTop:'20px' }}>
            <button disabled={filters.page<=1} onClick={() => setFilters(f=>({...f, page: Math.max(1, f.page-1)}))}  style={{ ...selStyle, cursor:'pointer', opacity:filters.page<=1?.4:1 }}>← Prev</button>
            <span style={{ color:'var(--muted)', fontSize:'13px', alignSelf:'center', fontFamily:'JetBrains Mono,monospace' }}>{filters.page} / {pages}</span>
            <button disabled={filters.page>=pages} onClick={() => setFilters(f=>({...f, page: Math.min(pages, f.page+1)}))}  style={{ ...selStyle, cursor:'pointer', opacity:filters.page>=pages?.4:1 }}>Next →</button>
          </div>
        )}
      </div>
    </div>
  );
}

const StatCard = ({ icon, val, label, color }) => (
  <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'14px 16px', boxShadow:'var(--shadow-sm)' }}>
    <div style={{ fontSize:'1.3rem', marginBottom:'6px' }}>{icon}</div>
    <div style={{ fontSize:'1.4rem', fontWeight:'600', color, fontFamily:'JetBrains Mono,monospace' }}>{val}</div>
    <div style={{ fontSize:'11px', color:'var(--muted)', marginTop:'3px' }}>{label}</div>
  </div>
);

const backBtn  = { background:'var(--bg)', border:'1px solid var(--border)', color:'var(--muted)', borderRadius:'var(--radius)', padding:'6px 14px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit' };
const selStyle = { background:'var(--bg)', border:'1px solid var(--border-md)', borderRadius:'var(--radius)', padding:'7px 12px', color:'var(--text)', fontFamily:'inherit', fontSize:'13px', outline:'none' };
